<template>
  <router-view></router-view>
</template>

<script>
import store from '@/store'

export default {
  name: 'StandardItemRoute',
  beforeRouteEnter (to, from, next) {
    return store.dispatch('standardItems/items/getItemForRoute', { to, from, next })
  },
  beforeRouteUpdate (to, from, next) {
    return store.dispatch('standardItems/items/getItemForRoute', { to, from, next })
  }
}
</script>
